package com.cybersoftsolution.cybersoftsolutionweb.components.sections


import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.components.collapse.CollapseContainer
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.ContentLayout
import com.cybersoftsolution.cybersoftsolutionweb.models.collapseQuestions
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px


@Composable
fun AboutSection(
    pageSection: PageSection,
    sectionModifier: Modifier = Modifier,
    contentModifier: Modifier = Modifier,
    icon: String? = null,
    title: String? =null,
    subtitle: String = "",
    text: String = "",
) {

    ContentLayout(
        title = title,
        pageSection = pageSection,
        sectionModifier = sectionModifier,
        contentModifier = contentModifier
    ){

        CollapseContainer(
            modifier = Modifier
                .margin(topBottom = 12.px),
            id = "questionCollapseContainerId",
            elements = collapseQuestions
        ){ element ->


            Column {
                SpanText(
                    modifier = Modifier
                        .margin(bottom = 10.px)
                        .fontSize(18.px)
                        .fontWeight(FontWeight.Bold),
                    text = element.question
                )
                SpanText(
                    text = element.answer
                )
                HorizontalDivider()

            }



        }

    }



}